module.exports = __webpack_public_path__ + "static/media/kitchen-scheme-dark.631a0df8.jpeg";